import CONSTANTS from '../CONSTANTS';

const initialState = {
  studies: [],
  page: 0,
  lastPage: 1,
  limit: 20,
  totalEntries: 0,
  study: {},
  loadingAiReview: false,
  loadingStudy: false,
  loadingStudyList: false,
  querySearch: "",
  canVote: false,
  shouldUpdateStudyList: false,
  laborListScroll: 0,
  comingFromDetails: false,
}
const laboratoryReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {

    case CONSTANTS.LAB_LOADING_STUDY_LIST:
      return {
        ...state,
        loadingStudyList: action.value
      };

    case CONSTANTS.LAB_LOADING_STUDY:
      return {
        ...state,
        loadingStudy: action.value
      };

    case CONSTANTS.LAB_SET_STUDIES:
      return { 
        ...state, 
        studies: [...action.studies.data],
        page: action.studies.page,
        lastPage: action.studies.lastPage,
        limit: action.studies.limit,
        totalEntries: action.studies.total,
        loadingStudyList: false
      };

    case CONSTANTS.LAB_SET_STUDY:
      return {
        ...state,
        study: {...action.study},
        loadingStudy: false,
      }
    
    case CONSTANTS.LAB_CAN_VOTE:
      return {...state, canVote: action.value}

    case CONSTANTS.LAB_LOADING_AI_COMMENT:
      return {
        ...state,
        loadingAiReview: action.value
      }

    case CONSTANTS.LAB_SET_SEARCH_QUERY: 
      return {
        ...state,
        querySearch: action.search
      }

    case CONSTANTS.LAB_SAVE_SCROLL: {
      return {
        ...state,
        laborListScroll: action.scroll
      }
    }

    case CONSTANTS.LAB_COMING_FROM_DETAILS: {
      return {...state, comingFromDetails: action.val};
    }
    
    case CONSTANTS.LAB_SET_PAGE_INDEX: {
      return {...state, page: action.val};
    }

    default:
      return state;
  }
};

export default laboratoryReducer;
